<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col class="pa-2" cols="12">
          <div class="rowinfo">
            <v-textarea
              v-model="computedValue.subtitle"
              append-icon="mdi-text"
              class="rounded-lg"
              clearable
              dense
              :label="$t('login_page_text')"
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-subtitle`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('login_page_text')"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "shopLoginConfig",

  props: {
    value: Object,
  },
  data() {
    return {
      serviceName: "Qrland",
      componentName: "shop-login-config",
      helpData: [],
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
